import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Input } from 'antd';
import styled, { system } from '@xstyled/styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledInput = styled(Input)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  height: ", ";\n"])), system, function (props) {
  return props.size === 'large' ? '36px' : '32px';
});
export var RootInput = function RootInput(props) {
  var type = props.type,
      size = props.size;
  return /*#__PURE__*/_jsx(StyledInput, _objectSpread(_objectSpread({}, props), {}, {
    type: type !== null && type !== void 0 ? type : 'text',
    size: size !== null && size !== void 0 ? size : 'large'
  }));
};